import axios from "@/utils/axios.js";
// import PageOptions from "@/models/PageOptions";

/**
 * Получение списка пользователей
 */
function getUsers( perPage, currentPage, sort, search, trashed = true) {
  return new Promise((resolve, reject) => {
    const params = {
      expand: 'roles,department,filiations'
    }
    if (trashed) params.trashed = trashed
    axios
        .get(`users?${sort ? `&sort=${sort}` : ''}${search ? `&search[All]=${search}` : ''}&per-page=${perPage}&page=${currentPage}`, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

function getUsersWithRole(role, perPage, currentPage, sort, search, trashed = true) {
  return new Promise((resolve, reject) => {
    const params = {}
    if (trashed) params.trashed = trashed
    axios
        .get(`users?expand=roles${sort ? `&sort=${sort}` : ''}&search[all]=${search ?? ''},${role ?? ''}&per-page=${perPage}&page=${currentPage}`, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

function getUserFromDepartament() {
  return new Promise((resolve, reject) => {
    axios
      .get(`users-department`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getPassengerWithoutDepartament() {
  return new Promise((resolve, reject) => {
    axios
      .get(`passengers-department`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Получение пользователя
 */
function getUser(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`users/${id}?expand=avatar,roles,department`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getUserFromDepartamentSearch(value) {
  return new Promise((resolve, reject) => {
    axios
      .get(`users-department?expand=roles&search[name]=${value}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getPassengerWithoutDepartamentSearch(value) {
  return new Promise((resolve, reject) => {
    axios
      .get(`passengers-department?expand=roles&search[All]=${value}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getUsersSearch(value) {
  return new Promise((resolve, reject) => {
    axios
        .get(`users?expand=roles,department&search[name]=${value}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

// получение руководителей
export function getHeads() {
  return new Promise((resolve, reject) => {
    axios
        .get(`heads`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

export function getUsersSearchWithRole(value, role) {
  return new Promise((resolve, reject) => {
    axios
        .get(`users?expand=roles,department&search[name]=${value}&search[role]=${role}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

export function getUserWithRole(role) {
  return new Promise((resolve, reject) => {
    axios
      .get(`users?expand=roles&search[role]=${role}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Создание пользователя
 * @param {String} name
 * @param {String} surname
 * @param {String} patronymic
 * @param {String} department_id
 * @param {String} email
 * @param {String} birthday
 * @param {String} password
 * @param {String} password_confirmation
 * @param {String} phone
 * @param {Array} roles
 * @param {String} filiation_id
 * @param {Number} document_id
 * @param {String} document_number
 * @param {String} document_validity
 * @param {Boolean} sex
 * @param {Boolean} should_change_password
 * @param {Boolean} is_vip
 * @param {Boolean} not_update_department
 */
function createUser(
  name,
  surname,
  patronymic,
  department_id,
  email,
  login,
  birthday,
  password,
  password_confirmation,
  phone,
  roles = [],
  filiation_id,
  document_id,
  document_number,
  document_validity,
  sex,
  should_change_password,
  is_vip,
  not_update_department
) {
  const userData = {
    name,
    surname,
    patronymic,
    department_id,
    email,
    login,
    birthday,
    password,
    password_confirmation,
    phone,
    roles,
    filiation_id,
    document_id,
    document_number,
    document_validity,
    sex,
    should_change_password,
    is_vip,
    not_update_department
  };

  return new Promise((resolve, reject) => {
    axios
      .post("users", userData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Восстановление пользователя
 */
function restoreUser(id) {
  return new Promise((resolve, reject) => {
    axios
      .post(`user/${id}/restore`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Восстановление пользователей (массив)
 */
function restoreUsers(ids) {
  return Promise.all(ids.map(({ id }) => restoreUser(id)));
}

/**
 * Удаление пользователя
 */
function deleteUser(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`users/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Удаление пользователей (массив)
 */
function deleteUserByIds(ids) {
  return Promise.all(ids.map(({ id }) => deleteUser(id)));
}

/**
 * Удаление пользователей
 */
function deleteUsers(ids) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`users`, { data: { users: ids } })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Редактирование пользователя
 * @param {Number} userId
 * @param {String} name
 * @param {String} surname
 * @param {String} patronymic
 * @param {String} department_id
 * @param {String} email
 * @param {String} login
 * @param {String} birthday
 * @param {String} phone
 * @param {Array} roles
 * @param {Array} head
 * @param {String} filiation_id
 * @param {Number} document_id
 * @param {String} document_number
 * @param {String} document_validity
 * @param {String} password
 * @param {String} password_confirmation
 * @param {Boolean} sex
 * @param {Boolean} should_change_password
 * @param {Boolean} is_vip
 * @param {Boolean} not_update_department
 */
function updateUser(
  userId,
  name,
  surname,
  patronymic,
  department_id,
  email,
  login,
  birthday,
  phone,
  roles,
  head,
  filiation_id,
  document_id,
  document_number,
  document_validity,
  password,
  password_confirmation,
  sex,
  should_change_password,
  is_vip,
  not_update_department
) {
  const userData = {
    name,
    surname,
    patronymic,
    department_id,
    email,
    login,
    birthday,
    phone,
    roles,
    head,
    filiation_id,
    document_id,
    document_number,
    document_validity,
    password,
    password_confirmation,
    sex,
    should_change_password,
    is_vip,
    not_update_department
  };

  return new Promise((resolve, reject) => {
    axios
      .put(`users/${userId}`, userData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function updatePassword(
  userId,
  password,
  confirmation_password,
) {
  const userData = {
    password,
    confirmation_password,
  };

  return new Promise((resolve, reject) => {
    axios
      .patch(`users/${userId}`, userData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function clearTickets(params) {
  return new Promise((resolve, reject) => {
    axios
        .post('/tickets-remove-files', params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

export { getUsers, getUsersWithRole, getUser, createUser, deleteUser, deleteUsers, updateUser, updatePassword, restoreUser, getUserFromDepartament, getPassengerWithoutDepartament, clearTickets, deleteUserByIds, restoreUsers };
